import { defineStore } from "pinia";
import Services from '@/services/sutting/departmentsServices'
import { mapList2Level, mapList, mapDepartment } from '@/helpers/mapFuncs'

export const useDepartmentsStore = defineStore("departments", {
persist: true,
state:()=>({
    department: {},
    departments: [],
}),
getters : {
    getDepartment() {
        return mapDepartment(this.department)
    },
    getDepartments() {
        return this.departments.map(mapDepartment)
    },
    getDepartmentsList() {
        return this.departments.map(mapList)
    },
    getDepartmentsList2Level() {
        return this.departments.map(mapList2Level)
    }
},
actions : {
    /** Start Sets */
    setDepartment(department) {
        this.department = department
    },
    setDepartments(departments) {
        this.departments = departments
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setDepartment(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setDepartments(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.departments.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.departments[this.departments.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.departments = this.departments.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
